import React from "react";
import CommandePage from "../../core/commande/CommandePage";

const horsPilulierContext = {
    filters: {
        classificationPatient: "LISTE_HP",
        source: "PORTAIL_COLLECTIVITE"
    },

    showMedicaments: false,

    medicamentStrategy: null
};

export default function HorsPilulier() {
    return (
        <CommandePage context={horsPilulierContext} />
    );
}
